/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Plan_Canceled_Success_MessageInputs */

const en_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.displayName} plan has been canceled`)
};

const id_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paket ${i?.displayName} Anda telah dibatalkan`)
};

const ms_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pelan ${i?.displayName} anda telah dibatalkan`)
};

const ca_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S'ha cancel·lat la teva subscripció ${i?.displayName}`)
};

const cs_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Váš plán ${i?.displayName} byl zrušen`)
};

const da_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dit ${i?.displayName}-abonnement er blevet opsagt`)
};

const de_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein ${i?.displayName}-Abonnement wurde gekündigt`)
};

const et_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teenuse ${i?.displayName} plaan on tühistatud`)
};

const es_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu suscripción de ${i?.displayName} se ha cancelado`)
};

const fr_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre abonnement ${i?.displayName} a été annulé.`)
};

const hr_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaša pretplata ${i?.displayName} je otkazana`)
};

const it_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo piano di abbonamento a ${i?.displayName} è stato cancellato`)
};

const lv_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jūsu ${i?.displayName} plāns ir atcelts`)
};

const lt_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jūsų ${i?.displayName} planas buvo atšauktas`)
};

const hu_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ${i?.displayName} tervét törölték`)
};

const nl_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je ${i?.displayName}-abonnement is opgezegd`)
};

const nb_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}-abonnementet ditt ble sagt opp`)
};

const pl_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Twoja usługa ${i?.displayName} została anulowana`)
};

const pt_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu plano ${i?.displayName} foi cancelado`)
};

const ro_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planul tău ${i?.displayName} a fost anulat`)
};

const sk_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Váš plán ${i?.displayName} bol zrušený`)
};

const sl_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaš načrt ${i?.displayName} je bil preklican.`)
};

const fi_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}-tilauksesi on peruutettu`)
};

const sv_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Din ${i?.displayName} plan har avbrutits`)
};

const vi_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gói ${i?.displayName} của bạn đã được hủy`)
};

const tr_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} planınız iptal edildi`)
};

const el_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Το πρόγραμμα ${i?.displayName} ακυρώθηκε`)
};

const bg_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Твоят план ${i?.displayName} е отменен`)
};

const ru_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш план ${i?.displayName} был отменен`)
};

const sr_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш пакет ${i?.displayName} је отказан`)
};

const uk_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш тарифний план ${i?.displayName} скасовано`)
};

const ka_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`თქვენი ${i?.displayName} გეგმა გაუქმებულია`)
};

const hi_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपका ${i?.displayName} प्लान कैंसिल हो गया है `)
};

const th_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แพ็กเกจ ${i?.displayName} ของคุณถูกยกเลิกแล้ว`)
};

const ko_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} 플랜이 취소되었습니다.`)
};

const zh_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的 ${i?.displayName} 套餐已取消`)
};

const zh_tw_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的 ${i?.displayName} 方案已取消`)
};

const ja_plan_canceled_success_message = /** @type {(inputs: Plan_Canceled_Success_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あなたの${i?.displayName} プランはキャンセルされました`)
};

/**
* | output |
* | --- |
* | "Your {displayName} plan has been canceled" |
*
* @param {Plan_Canceled_Success_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const plan_canceled_success_message = /** @type {((inputs: Plan_Canceled_Success_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Canceled_Success_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_canceled_success_message(inputs)
	if (locale === "ms") return ms_plan_canceled_success_message(inputs)
	if (locale === "ca") return ca_plan_canceled_success_message(inputs)
	if (locale === "cs") return cs_plan_canceled_success_message(inputs)
	if (locale === "da") return da_plan_canceled_success_message(inputs)
	if (locale === "de") return de_plan_canceled_success_message(inputs)
	if (locale === "et") return et_plan_canceled_success_message(inputs)
	if (locale === "es") return es_plan_canceled_success_message(inputs)
	if (locale === "fr") return fr_plan_canceled_success_message(inputs)
	if (locale === "hr") return hr_plan_canceled_success_message(inputs)
	if (locale === "it") return it_plan_canceled_success_message(inputs)
	if (locale === "lv") return lv_plan_canceled_success_message(inputs)
	if (locale === "lt") return lt_plan_canceled_success_message(inputs)
	if (locale === "hu") return hu_plan_canceled_success_message(inputs)
	if (locale === "nl") return nl_plan_canceled_success_message(inputs)
	if (locale === "nb") return nb_plan_canceled_success_message(inputs)
	if (locale === "pl") return pl_plan_canceled_success_message(inputs)
	if (locale === "pt") return pt_plan_canceled_success_message(inputs)
	if (locale === "ro") return ro_plan_canceled_success_message(inputs)
	if (locale === "sk") return sk_plan_canceled_success_message(inputs)
	if (locale === "sl") return sl_plan_canceled_success_message(inputs)
	if (locale === "fi") return fi_plan_canceled_success_message(inputs)
	if (locale === "sv") return sv_plan_canceled_success_message(inputs)
	if (locale === "vi") return vi_plan_canceled_success_message(inputs)
	if (locale === "tr") return tr_plan_canceled_success_message(inputs)
	if (locale === "el") return el_plan_canceled_success_message(inputs)
	if (locale === "bg") return bg_plan_canceled_success_message(inputs)
	if (locale === "ru") return ru_plan_canceled_success_message(inputs)
	if (locale === "sr") return sr_plan_canceled_success_message(inputs)
	if (locale === "uk") return uk_plan_canceled_success_message(inputs)
	if (locale === "ka") return ka_plan_canceled_success_message(inputs)
	if (locale === "hi") return hi_plan_canceled_success_message(inputs)
	if (locale === "th") return th_plan_canceled_success_message(inputs)
	if (locale === "ko") return ko_plan_canceled_success_message(inputs)
	if (locale === "zh") return zh_plan_canceled_success_message(inputs)
	if (locale === "zh-tw") return zh_tw_plan_canceled_success_message(inputs)
	if (locale === "ja") return ja_plan_canceled_success_message(inputs)
	return en_plan_canceled_success_message(inputs)
});